<template>
  <div class="container">
    <div class="message">
      <h2 class="title">Twitter Authorizing</h2>
      <p class="text">
        <span v-if="loading">Wait...</span>
        <span v-else-if="success"
          >Authorize is successfull, page will be closed after
          {{ leftTime }} seconds</span
        >
        <span v-else
          >Authorize has failed, page will be closed after
          {{ leftTime }} seconds</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { verifyTwitter } from "@/api/socials/twitter.js";

// @group Socials
// Callback page for Twitter OAuth
export default {
  name: "TwitterCallbackPage",
  props: {
    /** OAuth access token */
    token: {
      type: String,
      required: true
    },
    /** OAuth access secret */
    verifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /** is credentials sending to server */
      loading: true,
      /** is credentials sent successfully */
      success: false,
      /** left time to close page */
      leftTime: 5
    };
  },
  watch: {
    // @vuese
    // Close page when counter go to 0
    leftTime() {
      if (this.leftTime == 0) {
        setTimeout(() => window.close(), 1000);
      }
    }
  },
  mounted() {
    /** Verify twitter authentication */
    verifyTwitter(this.token, this.verifier)
      .then(() => {
        this.loading = false;
        this.success = true;
        this.startCounter();
      })
      .catch(() => {
        this.loading = false;
        this.startCounter();
      });
  },
  methods: {
    // @vuese
    // Start countdown to close page
    startCounter() {
      const intervaKey = setInterval(() => {
        if (this.leftTime > 0) {
          this.leftTime--;
        } else {
          clearInterval(intervaKey);
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
}
.message {
  width: fit-content;
  margin: auto;
}
.title {
  text-align: center;
  font-size: 2rem;
}
.text {
  text-align: center;
  font-size: 1.25rem;
}
</style>

<style>
body {
  background-color: #a1a1a1;
  color: white;
}
</style>
